export enum EmailNotification {
  DISABLED = 0,
  ENABLED = 1,
}

export const EmailNotificationDisplayEnum: Record<EmailNotification, string> = {
  [EmailNotification.DISABLED]: 'OFF',
  [EmailNotification.ENABLED]: 'ON',
};
